import {Button} from '@chekinapp/ui';
import styled, {css} from 'styled-components';
import {DEVICE} from '@chekin/guestapp-ui-kit';
import {StyledStatusModal} from '@chekin/shared';

export const Container = styled.div`
  display: flex;
  max-width: 375px;
  width: 100%;
  padding: 16px;
  margin: 0 auto;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  border-radius: 6px;
  border: 1px solid var(--texts-borders-grey-border, rgba(0, 0, 0, 0.1));
  background: ${props => props.theme.colors.branding.boxesModals};
`;

export const Header = styled.div`
  display: flex;
  align-self: flex-start;
  align-items: center;
  font-size: 14px;
  line-height: 24px;
  color: ${props => props.theme.colors.branding.fontPrimary};
  font-weight: 400;

  & > img:nth-child(2) {
    margin: 0 10px 0 8px;
  }
`;

export const Form = styled.form`
  width: 100%;
`;

export const Hr = styled.div`
  height: 1px;
  width: 100%;
  background: #0000001a;
`;

export const TotalBox = styled.div`
  display: flex;
  width: 100%;
  padding: 16px 24px;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 16px;
  background: ${props => props.theme.colors.branding.backgroundSecondary};
  color: ${props =>
    props.theme.hasTemplate
      ? props.theme.colors.branding.fontSecondary
      : props.theme.colors.$p10};

  & > span:first-child {
    font-weight: 600;
  }

  & > span:last-child {
    font-weight: 700;
  }
`;

export const Price = styled.span<{$isLoaded?: boolean}>`
  opacity: 0.5;
  transition: opacity 0.2s ease-in-out;

  ${props =>
    props.$isLoaded &&
    css`
      opacity: 1;
    `}
`;

export const StyledButton = styled(Button)`
  width: 100%;
`;

export const StyledPreAuthorization3DSInfoModal = styled(StyledStatusModal)`
  &-content {
    & .modal__title {
      margin-top: 0;
    }
  }

  @media (min-width: ${DEVICE.mobileXL}) {
    &-content {
      max-width: 555px;
    }
  }
`;
